import CheckBox from '@app/components/CheckBox'
import { IContextReminder } from '@app/models/ContextReminder'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { actionCreators } from '../modules/contextReminder'

interface IComponentProps {
  reminder: IContextReminder
}

export default class ContextReminderContainer extends React.PureComponent<
  IComponentProps & typeof actionCreators,
  {}
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='mt-2' style={{ width: '50%' }}>
        <CheckBox
          className='d-flex flex-row justify-content-between align-items-center'
          value={this.props.reminder.isComplete}
          onChange={(e) => {
            this.props.toggleReminderComplete(this.props.reminder, e)
          }}
        >
          <span
            className={
              this.props.reminder.isComplete
                ? 'text-muted mr-auto pl-2'
                : 'mr-auto pl-2'
            }
            style={{
              textDecoration: this.props.reminder.isComplete
                ? 'line-through'
                : '',
            }}
          >
            {this.props.reminder.text}
          </span>
          <div
            onClick={() => {
              this.props.deleteReminder(this.props.reminder.id)
            }}
          >
            <FontAwesomeIcon
              className='ml-2 text-danger'
              icon={['fal', 'trash']}
            />
          </div>
        </CheckBox>
      </div>
    )
  }
}
